export const ANALYTICS_EVENTS = {
    USER: {
        SIGNUP: 'user_signup',
        LOGIN: 'user_login',
        LOGOUT: 'user_logout',
        PROFILE_UPDATE: 'profile_update',
        EMAIL_VERIFY: 'email_verify'
    },
    FEATURE: {
        PAGE_VIEW: 'page_view',
        SUBSCRIPTION_ADD: 'subscription_add',
        SUBSCRIPTION_DELETE: 'subscription_delete',
        ANALYTICS_VIEW: 'analytics_view',
        WISHLIST_JOIN: 'wishlist_join',
        SEARCH: 'search_performed',
        FILTER_APPLY: 'filter_applied',
        SORT_APPLY: 'sort_applied'
    },
    BUSINESS: {
        SUBSCRIPTION_UPGRADE: 'plan_upgrade',
        PAYMENT_INITIATED: 'payment_initiated',
        PAYMENT_COMPLETED: 'payment_completed',
        FEATURE_UNLOCK: 'feature_unlocked'
    },
    SYSTEM: {
        ERROR: 'error_occurred',
        API_LATENCY: 'api_latency',
        FEATURE_FLAG: 'feature_flag_check'
    }
};

export const ANALYTICS_CONFIG = {
    ENDPOINT: '/g-analytics/events',
    BATCH_SIZE: 10,
    FLUSH_INTERVAL: 5000,
    DEBUG: process.env.NODE_ENV === 'development'
}; 